module.exports = __webpack_public_path__ + "assets/img/flag-tr.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-tr.png
// module id = 57
// module chunks = 0